<template>
  <div :class="['image__loading', { '--loaded': loaded }]" :style="loadingImage">
    <img
      v-if="source"
      :alt="source.data?.alt ?? ''"
      :src="source.thumb ?? source.original"
      :srcset="srcset"
      :title="source.data?.title ?? ''"
      :sizes="sizes"
      loading="lazy"
      class="image"
      ref="image"
    />
  </div>
</template>

<script>
export const IMAGE_RESOLUTIONS = {
  ld: 20,
  lg: 1920,
  md: 1024,
  original: 1921,
  sm: 800,
  thumb: 150,
}

export default {
  name: 'Image',
  props: {
    sizes: {
      type: String,
      default: '',
    },
    source: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loaded: false,
    }
  },
  computed: {
    loadingImage() {
      if (!this.source) return null

      const image = this.source.ld ?? this.source.original
      return `background-image: url(${image})`
    },
    srcset() {
      if (!this.source) return null

      const resolutions = Object.keys(IMAGE_RESOLUTIONS)
      return Object.entries(this.source)
        .filter((src) => resolutions.includes(src[0]))
        .toSorted((srcA, srcB) => IMAGE_RESOLUTIONS[srcA[0]] - IMAGE_RESOLUTIONS[srcB[0]])
        .map((src) => `${src[1]} ${IMAGE_RESOLUTIONS[src[0]]}w`)
        .join(', ')
    },
  },
  methods: {
    bindLoadListener() {
      if (!this.$refs.image) return

      if (this.$refs.image.complete) {
        this.updateLoaded()
        return
      }

      this.$refs.image.addEventListener('load', this.updateLoaded)
    },
    updateLoaded(isLoaded = true) {
      this.loaded = isLoaded
    },
  },
  mounted() {
    this.bindLoadListener()
  },
  beforeUnmount() {
    this.$refs.image?.removeEventListener('load', this.updateLoaded)
  },
  watch: {
    source() {
      this.loaded = false
      this.$nextTick(this.bindLoadListener)
    },
  },
}
</script>
